import { trigger, transition, style, animate } from '@angular/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FourDInjector } from '../../../FourDInjector';
import { BucketsComponent } from '../buckets.component';



@Component({
  selector: 'fdm-bucket',
  templateUrl: './bucket.component.html',
  styleUrls: ['./bucket.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateX(-100%)', opacity: 0, height:0 }),
        animate('0.2s 120ms ease-in-out', style({transform: 'translateX(0%)', opacity:1, height:'100%' }))
      ]),
      transition(':leave', [
        animate('0.2s 120ms ease-in-out', style({transform: 'translateX(-100%)', opacity:0, height:0 }))
      ])
    ])
  ]
})
export class BucketComponent implements OnInit {

  debug:boolean = false;

  @Input()
  plugin:any = null;

  index:number = 0;

  showMe:boolean = false;

  translate: TranslateService = null;
  
  // items:any = [];

  controller:any = null;

  textual:string = null;

  id:string = this.uuidv4();

  uuidv4( token:string = '_', prefix:string = 'uuid_') {
    return ( prefix + 'xxxxxxxx'+token+'xxxx'+token+'4xxx'+token+'yxxx'+token+'xxxxxxxxxxxx').replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

  // parent buckets controller
  buckets:BucketsComponent = null;
  
  constructor( public _parent: BucketsComponent ) { 
    this.buckets = _parent;
    this.translate = FourDInjector.injector.get(TranslateService);
  }

  timePasses:number = 0;

  myIndex() {

    /* this.timePasses--;
    if ( this.timePasses > 0 ) {
      return this.index;
    }
    this.timePasses = 50; */

    let idx = 0;
    let token = this.controller.id;

    if ( this.controller && this.buckets ) {
      if ( this.controller.selectedItem ) {
        this.buckets.isActive(token);
      } else {
        this.buckets.isInactive(token);
      }
      idx = this.buckets.getMyIndex(token);
    }
    this.index = idx;
    return idx;
  }

  myRight() {
    return ( 30 + ( this.index * 400 ) ) + 'px';
  }

  ngOnInit() {
    
    if ( this.plugin ) {
      this.plugin.registerComponent(this);
      if ( this.plugin.config && this.plugin.config.languageToken ) {
        this.textual = 'PLUGINS.BUCKET.'+ this.plugin.config.languageToken + '.';
      }
      if ( this.plugin.config && this.plugin.config.controller ) {
        this.controller = this.plugin.config.controller;
      }
    }
    if ( this.debug ) { console.log ( 'BUCKET comp INIT', this.textual, this.plugin, this.controller ); }
  }
  
}
